import { useCallback, useState } from 'react';
import { useQuery } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { useDownloadCSV, useGetEmployerIdParam } from '../../hooks';
import { CIPStatusSummaryReportParams } from '../CIPStatusReport.types';

export const QUERY_KEY = 'EXPORT_CIP_STATUS_SUMMARY_REPORT_CSV';
const useForfeitureReportExportSummaryCSVQuery = (params: CIPStatusSummaryReportParams) => {
  const handleSaveFile = useDownloadCSV();
  const [isLoading, setIsLoading] = useState(false);
  const getEmployerIdParam = useGetEmployerIdParam({
    isMultipleEmployerMode: params.isMultipleEmployer || false,
  });
  const employerId = getEmployerIdParam(params.employerId, params.employerIds);

  const { refetch } = useQuery(
    [QUERY_KEY],
    () =>
      api.get(
        params.isMultipleEmployer
          ? API_URL.REPORTS_CIP_STATUS_REPORT_MULTI_EMPLOYERS_SUMMARY_EXPORT_CSV
          : API_URL.REPORTS_CIP_STATUS_REPORT_SUMMARY_EXPORT_CSV,
        {
          params: _.pickBy({
            ...employerId,
          }),
        }
      ),
    {
      retry: 0,
      enabled: false,
    }
  );

  const handleExport = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await refetch();
      handleSaveFile(response?.data?.data, 'csv', 'cip-status_summary_report');
    } finally {
      setIsLoading(false);
    }
  }, [handleSaveFile, refetch]);
  return {
    isLoading,
    handleExport,
  };
};

export default useForfeitureReportExportSummaryCSVQuery;
